<template>
  <el-dialog
    v-if="isShow"
    title="Upload Attachment"
    :visible.sync="isShow"
    top="5vh"
    style="text-align: center;"
    :close-on-click-modal="false"
  >
    <el-upload
      ref="uploader"
      action=""
      :auto-upload="false"
      :on-change="(file, fileList) => files = fileList"
      :on-remove="(file, fileList) => files = fileList"
      drag
      multiple
    >
      <i class="el-icon-upload" />
      <div class="el-upload__text">
        Drop file here or <em>click to upload</em>
      </div>
    </el-upload>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="isShow = false">
        Cancel
      </el-button>
      <el-button
        type="primary"
        :loading="isSaving"
        @click.native="upload"
      >
        Upload
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    accountId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isShow: false,
      isSaving: false,
      files: []
    }
  },
  methods: {
    async upload () {
      this.isSaving = true
      await Promise.all(this.files.map(async file => {
        try {
          const uploadedFile = await this.$file.upload(file.raw, undefined, file.name)
          await this.$file.setAttachment(uploadedFile.data.file.id, this.accountId)
        } catch (e) {
          this.$message({ message: `An error occurred while uploading: ${file.name || '-'}`, type: 'error' })
        }
      }))

      this.isSaving = false
      this.isShow = false
      this.$emit('saved')
    }
  }
}
</script>
